<template lang="pug">
    v-card
        //crud-create-button(
            :action="submitCreateAccount"
            text="Crear Cuenta"
            v-if="$can('CREATE_ACCOUNT')"
            )
        //crud-create-button.accTree(
            text="Vista Cuentas"
            icon="view_list"
            :buttonProps="{color:'success'}"
            :action="submitOpenAccountTree"
            v-if="$can('VIEW_ALL_ACCOUNT_TYPE')"
            )
        model-data-table(
            :headers="headers"
            :filters="filters"
            :service="model"
            no-detail
        )
            template( slot='actions' slot-scope='props' )
                v-btn( color='success' icon flat @click='handleClickExport(props)' )
                    v-icon cloud_download
        dialog-create-account(ref="refDialogCreateAccount" @success="refresh")
        dialog-account-details(ref="refDialogAccountDetails" :accountObj="accountObj" @success="refresh")
        dialog-account-tree(
            :accounts="accounts"
            :accountTypes="accountTypes"
            :show="activeTreePicker"
            @show="activeTreePicker = $event"
            ref="refDialogAccountTree"
            )
        loading-dialog(:loading="loadingData")

        //
        v-dialog( v-model='dialogs.export' width='800' )
            model-form( 
                :loading='exportLoading'
                title='Saldo y movimientos' 
                reset-text='cancelar' 
                submit-text='descargar' 
                v-bind='exportProps'
                v-model='exportData'
                @reset='dialogs.export = false'
                @submit='handleSubmitExport'
                )
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import {
    CrudDataTable,
    CrudCreateButton,
    DTService,
} from '@/components/reusable_components'
import HeadersAccounts from './HeadersAccounts'
import { createAccounts, deleteAccounts } from '@/services/api/account'
import DialogCreateAccount from './dialog/DialogCreateAccount'
import DialogAccountDetails from './dialog/DialogAccountDetails'
import DialogAccountTree from '@/components/dialogs/accountTree/DialogAccountTree'
import { getAllAccounts, getAllAccountTypes } from '@/services/api/account'
import LoadingDialog from '@/components/reusable_components/LoadingDialog/LoadingDialog'
//
import AccountService from '@/services/api/accounting/account'
import AccountTypeService from '@/services/api/accounting/account-type'
import AccAccount from '@/models/Accounting/AccAccount'
import { ModelDataTable, ModelForm } from '@/components/reusable_components/next'
//
import GBranchOfficeModel from '@/models/General/GBranchOffice'
import TranslatorService from '@/services/translator'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'
//-
export default {
    name: 'list-accounts',
    props: {},
    data: function() {
        return {
            filters: AccountService.filters,
            service: {
                dtFetchData: () => {},
            },
            headers: HeadersAccounts,
            accountObj: {},
            deleteId: 0,
            activeTreePicker: false,
            accounts: [],
            accountTypes: [],
            loadingData: false,
            model: AccAccount,
            dialogs: {
                export: false,
            },
            exportData: {
                g_branch_offices: [],
                init_date: '',
                end_date: '',
                name: '',
                acc_accounts: [],
            },
            exportLoading: false,
            exportTitle: '',
        }        
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        exportProps() {
            return {
                fields: [
                    {
                        name: 'name',
                        type: 'text-field',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            readonly: true,
                            label: 'Nombre',
                        },
                    },
                    {
                        name: 'g_branch_offices',
                        type: 'autocomplete-model',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Sucursal',
                            model: GBranchOfficeModel,
                            itemText: 'name',
                            itemValue: 'id',
                            multiple: true,
                            noObject: true,
                            paramSearch: 'name',
                        },
                    },
                    {
                        name: 'init_date',
                        type: 'date-field',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Fecha de Inicio',
                            rules: [RequiredRule],
                        },
                    },
                    {
                        name: 'end_date',
                        type: 'date-field',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Fecha de Término',
                            rules: [RequiredRule],
                        },
                    },
                ],
            }
        },
    },
    methods: {
        // -- Data fetching
        getListAccounts: function() {
            const includes = [
                'acc_account_type',
                'acc_parent_account',
                'acc_children_accounts',
            ]
            const url = process.env.VUE_APP_API_ROUTE.concat(`/acc_account`)
            this.service.dtFetchData = DTService.getFetchDataFunction(
                url,
                includes,
                []
            )
        },
        loadAccounts: async function() {
            let accs = await getAllAccounts()
            let accTypes = await getAllAccountTypes()
            this.accounts = accs.data
            this.accountTypes = accTypes.data
        },
        //-- Validations
        refresh: function() {
            this.setLoadingDataSpinner(true)
            this.$refs.refDTAccountsList.checkAndFetch()
            this.loadAccounts()
            this.setLoadingDataSpinner(false)
        },
        setLoadingDataSpinner(value) {
            this.loadingData = value
        },
        //-- Show dialogs & views
        submitCreateAccount: function() {
            this.$refs.refDialogCreateAccount.open = true
        },
        submitOpenAccountTree: function() {
            this.$refs.refDialogAccountTree._show = true
        },
        submitShowAccountDetail: function(event) {
            this.accountObj = event
            this.$refs.refDialogAccountDetails.open = true
        },
        submitDelete: function(event) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            //-
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar cuenta contable?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.deleteId = event
        },
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        handleClickExport(event) {
            this.dialogs.export = true
            this.exportData.acc_accounts = [event.item.id]
            this.exportData.name = event.item.name
            this.accAccount = event.item
        },

        /**
         * 
         */
        handleSubmitExport(event) {
            this.toGetAccountMovementAndBalance()
        },

        /**
         * 
         */
        async toGetAccountMovementAndBalance() {
            this.exportLoading = true
            this.accAccount.getMovementAndBalance(this.exportData)
                .then(() => {
                    this.dialogs.export = false
                })
                .catch(this.onError)
                .finally(() => {
                    this.exportLoading = false
                })
        },

        /**
         * 
         */
        onError(error) {
            this.showErrorSnackbar(TranslatorService(AccAccount, error.response.data))
        },
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deleteAccounts(this.deleteId)
                //-
                if (response.status == 'success') {
                    this.setLoadingDataSpinner(false)
                    let payload = this.fillSnack(
                        'success',
                        'Cuenta contable eliminada con éxito',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTAccountsList.checkAndFetch()
                    this.loadAccounts()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-create-button': CrudCreateButton,
        'crud-data-table': CrudDataTable,
        'dialog-create-account': DialogCreateAccount,
        'dialog-account-details': DialogAccountDetails,
        'dialog-account-tree': DialogAccountTree,
        'loading-dialog': LoadingDialog,
        'model-data-table': ModelDataTable,
        'model-form': ModelForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.loadAccounts()
    },
    mounted: async function() {
        this.setTitleTopBar('Cuentas')
        this.getListAccounts()
        this.filters[0].options = await AccountTypeService.fetchAll()
        this.setItems([
            {
                text: 'ver arbol de cuentas',
                icon: 'visibility',
                color: 'success',
                action: this.submitOpenAccountTree,
            },
            {
                text: 'crear cuenta',
                icon: 'add_circle',
                action: this.submitCreateAccount,
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ACCOUNT')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.accTree {
    right: 300px;
}
</style>
